import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const HeroSection = ({ timeContent }) => {
  const [scrollY, setScrollY] = useState(0);
  const [badgeIndex, setBadgeIndex] = useState(0);

  const badgeWords = [
    "Premium Cinematography",
    "Premium Branding",
    "Premium Web Development",
    "Social Media Management",
  ];

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setBadgeIndex((prev) => (prev + 1) % badgeWords.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      data-theme="dark"
      className="relative h-screen w-screen overflow-hidden bg-command-center"
    >
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          className="h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          style={{ transform: `translateY(${scrollY * 0.5}px)` }}
        >
          <source src="/assets/images/video1.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/70" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        <div className="flex w-full max-w-4xl flex-col items-center justify-center gap-6 md:gap-10">
          {/* TOP — Badge */}
          {/* <div className="mt-8 md:mt-0">
            <span className="inline-block rounded-full bg-accent/10 px-4 py-2 text-xs sm:text-sm  font-medium text-accent backdrop-blur-sm">
              {timeContent.greeting} • {badgeWords[badgeIndex]}
            </span>
          </div> */}
          <div className="mt-8 md:mt-0">
            <span className="inline-block rounded-full bg-accent/10 px-4 py-2 text-xs sm:text-sm md:text-base font-medium text-accent backdrop-blur-sm">
              {timeContent.greeting}, welcome to HYPE!
            </span>
          </div>
          {/* MIDDLE — Headline + Copy */}
          <div className="flex flex-col items-center justify-center space-y-4 md:space-y-12">
            <h1 className="text-4xl font-bold leading-tight text-white md:text-7xl">
              Where <span className="text-red-600">Precision</span>
            </h1>
            <h1 className="text-4xl font-bold leading-tight text-white md:text-7xl">
              Meets <span className="text-red-600">Artistry</span>
            </h1>
            <p className="mx-auto max-w-3xl text-xl font-bold leading-relaxed text-white/90 md:text-3xl">
              Visibility <span className="text-red-600">• Credibility •</span>{" "}
              Conversion
            </p>
            <p className="mx-auto max-w-3xl text-lg leading-relaxed text-white/90 md:text-2xl">
              Engineering cinematic experiences that elevate corporate brands,
              crafting a perfect fusion of technical mastery and creative
              vision.
            </p>
          </div>

          {/* BOTTOM — CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/cinematic-showcase-portfolio"
              className="bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-lg font-semibold cinematic-transition cta-glow"
            >
              <Icon
                name="Play"
                size={20}
                strokeWidth={2}
                className="hidden lg:inline-flex"
              />
              <span>View Our Work</span>
            </Link>

            <Link
              to="/booking-concierge-premium-consultation"
              className="border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-4 rounded-lg font-semibold cinematic-transition"
            >
              <Icon
                name="Calendar"
                size={20}
                strokeWidth={2}
                className="hidden lg:inline-flex"
              />
              <span>Schedule Consultation</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 flex">
        <div className="flex flex-col items-center">
            <span className="text-white/60 text-sm mb-4">Discover More</span>
            <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-accent rounded-full mt-2 animate-bounce" />
            </div>
          </div>
      </div>
    </section>
  );
};

export default HeroSection;
